module.exports = __webpack_public_path__ + "static/img/car.c97b209.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car.svg
// module id = 119
// module chunks = 1